export const ApiKey = 'esgi-apigateway';